import React from 'react';

interface ShippingButtonsProps {
}

const ShippingButtons: React.FC<ShippingButtonsProps> = ({  }) => {
    return (
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="submit"
          className="w-full sm:w-auto flex-grow text-white font-semibold py-3 px-6 rounded-lg transition duration-150 text-base btn-primary"
        >
          Ir para Pagamento
        </button>
      </div>
    );
};

export default ShippingButtons; 